
import Vue from "vue";
import Component from "vue-class-component";
import SimpleBreadcrumbs from "@/components/SimpleBreadcrumbs.vue";
import ListaProdutos from "../components/produtos/ListaProdutos.vue";
import { Prop, Watch } from "vue-property-decorator";
import FiltroOrdenacaoProdutos from "../components/produtos/filters/Ordenacao.filter.vue";
import FiltroCategoriaProdutos from "../components/produtos/filters/Categoria.filter.vue";
import ProdutosService from "@/services/ProdutosService";
import { namespace } from "vuex-class";

const Auth = namespace("Auth");

@Component({
  name: "BuscaProdutosView",
  components: {
    FiltroOrdenacaoProdutos,
    SimpleBreadcrumbs,
    ListaProdutos,
    FiltroCategoriaProdutos,
  },
})
export default class BuscaProdutosView extends Vue {
  @Prop({ default: "" }) sortId!: string;
  @Prop({ default: "" }) grupo!: string;
  @Prop({ default: "" }) subgrupo!: string;
  @Prop({ default: "" }) familia!: string;
  @Prop({ default: "" }) marca!: string;
  @Prop({ default: "" }) prodSearch!: string;
  @Prop({ default: "" }) page!: string;
  @Prop({ default: "" }) itemsPerPage!: string;
  @Prop({ default: "" }) grupoProdutos!: string;

  @Auth.Getter isLoggedIn!: boolean;

  drawerstate = false;
  produtos = Promise.resolve([]);
  loadingItems = true;

  get mobileBreakpoint() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  mounted() {
    this.produtos = this.fetchProdutos() as any;
  }

  @Watch("sortId")
  @Watch("prodSearch")
  @Watch("page")
  @Watch("itemsPerPage")
  @Watch("grupoProdutos")
  @Watch("isLoggedIn")
  @Watch("grupo")
  @Watch("subgrupo")
  @Watch("familia")
  @Watch("marca")
  onParameterChanged() {
    this.produtos = this.fetchProdutos() as any;
  }

  baseFilters(filters: any) {
    this.produtos = this.fetchProdutos() as any;
  }

  @Watch("mobileBreakpoint")
  onMobileBreakpointChanged(value: any) {
    if (value) {
      this.drawerstate = false;
    }
  }

  async fetchProdutos(){
    const page = parseInt(this.page) || 1;
    const itemsPerPage = parseInt(this.itemsPerPage) || 20;
    const search = this.prodSearch || "";
    const sortId = this.sortId || "";
    const grupoProdutos = parseInt(this.grupoProdutos) || undefined;
    let baseFilters = [];

    // grupo from filtroCategoria
    if(this.grupo || this.subgrupo || this.familia || this.marca){
      const refFiltroCategoria = this.$refs.filtroCategoria as any;
      const filters = refFiltroCategoria?.getGrupoBySlug(this.grupo, this.subgrupo, this.familia, this.marca);
      baseFilters = filters;
    }


    let ordenacao = ProdutosService.listaOrdenacaoMap?.[sortId]?.ord;
    if (!ordenacao && !this.grupoProdutos)
      ordenacao = { sortBy: ["produto.descricao_portal"] };


    return await ProdutosService.findAllCliente({
      paginacao: {
        page,
        itemsPerPage,
        sortBy: ordenacao?.sortBy,
        sortDesc: ordenacao?.sortDesc,
      },
      searchStr: search,
      filters: baseFilters || [],
      grupoProdutos: grupoProdutos,
    }).then((res) => ({
      data: res.data,
      totalrecordcount: res.totalrecordcount,
    }));
  }

  get filtroWidth() {
    if (this.$vuetify.breakpoint.lg) return "280px";
    if (this.$vuetify.breakpoint.xl) return "350px";
    return "400px";
  }
}
